import {
  useCurrentUser,
  useGetUserById,
  useGetUserByUserName,
} from '@wellesley/user'

type HookProps =
  | {
      username?: string
      canFetch?: boolean
      htmlContent?: boolean
    }
  | {
      userId: string
      canFetch?: boolean
      htmlContent?: boolean
      allowDeleted?: boolean
    }

const useProfile = (props: HookProps) => {
  const { user: myProfile, isLoading: isMyProfileLoading } = useCurrentUser()

  const hasUserId = 'userId' in props && !!props.userId
  const hasUsername = 'username' in props && !!props.username

  const isOwnProfile =
    (hasUsername && myProfile?.username === props.username) ||
    (hasUserId && myProfile?.id === props.userId)

  const useRawContent = props.htmlContent === false
  const shouldSkipFetch = isOwnProfile && useRawContent && !!myProfile

  const {
    data: user,
    isLoading: isUserLoading,
    error: userError,
  } = useGetUserByUserName({
    ...props,
    canFetch: !hasUserId && !shouldSkipFetch && (props.canFetch ?? true),
  })

  const { data: userDataById, isLoading: isUserLoadingById } = useGetUserById({
    userId: hasUserId ? props.userId : '',
    htmlContent: props.htmlContent ?? false,
    canFetch: hasUserId && !shouldSkipFetch && (props.canFetch ?? true),
  })

  const isLoading = shouldSkipFetch
    ? isMyProfileLoading
    : isMyProfileLoading ||
      (!hasUserId && isUserLoading) ||
      (hasUserId && isUserLoadingById)
  const isError = !!userError

  const fetchedUser = hasUserId ? userDataById || user : user
  const profileUser = shouldSkipFetch ? myProfile : fetchedUser

  return [profileUser, isOwnProfile, isLoading, isError] as const
}

export default useProfile
